export default function formatDate(date) {
  const dateString = date.toLocaleString();
  const dateArray = dateString.split(',');
  const dateValues = dateArray[1].split(':');
  return dateValues;
}
